module.exports = __webpack_public_path__ + "static/media/photo_add.42b16b8b.svg";